// import React from 'react';

// const logos = [
//   { src: 'https://tailwindui.com/plus/img/logos/158x48/transistor-logo-gray-900.svg', alt: 'Transistor' },
//   { src: 'https://tailwindui.com/plus/img/logos/158x48/reform-logo-gray-900.svg', alt: 'Reform' },
//   { src: 'https://tailwindui.com/plus/img/logos/158x48/tuple-logo-gray-900.svg', alt: 'Tuple' },
//   { src: 'https://tailwindui.com/plus/img/logos/158x48/savvycal-logo-gray-900.svg', alt: 'SavvyCal' },
//   { src: 'https://tailwindui.com/plus/img/logos/158x48/statamic-logo-gray-900.svg', alt: 'Statamic' },
// ];

// const duplicatedLogos = [...logos, ...logos];

// const LogoScrollLTR = () => (
//   <div className="w-full bg-white py-8">
//     <h1 className="text-2xl md:text-4xl font-bold text-center mb-8 text-gray-900">Our Trusted Partners</h1>
//     <div className="relative overflow-hidden">
//       {/* Gradient fade on edges */}
//       <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white to-transparent z-10" />
//       <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white to-transparent z-10" />
//       {/* Scrolling logos */}
//       <div className="flex space-x-12 animate-logo-scroll-ltr group-hover:paused">
//         {duplicatedLogos.map((logo, idx) => (
//           <img
//             key={idx}
//             src={logo.src}
//             alt={logo.alt}
//             className="h-10 w-auto object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
//             loading="lazy"
//           />
//         ))}
//       </div>
//     </div>
//     {/* Custom animation */}
//     <style>{`
//       @keyframes logo-scroll-ltr {
//         0% { transform: translateX(-50%); }
//         100% { transform: translateX(0%); }
//       }
//       .animate-logo-scroll-ltr {
//         animation: logo-scroll-ltr 10s linear infinite;
//         will-change: transform;
//       }
//       .group:hover .animate-logo-scroll-ltr,
//       .animate-logo-scroll-ltr:hover {
//         animation-play-state: paused;
//       }
//     `}</style>
//   </div>
// );

// export default LogoScrollLTR;



import React from 'react';

const logos = [
  { src: 'https://tailwindui.com/plus/img/logos/158x48/transistor-logo-gray-900.svg', alt: 'Transistor' },
  { src: 'https://tailwindui.com/plus/img/logos/158x48/reform-logo-gray-900.svg', alt: 'Reform' },
  { src: 'https://tailwindui.com/plus/img/logos/158x48/tuple-logo-gray-900.svg', alt: 'Tuple' },
  { src: 'https://tailwindui.com/plus/img/logos/158x48/savvycal-logo-gray-900.svg', alt: 'SavvyCal' },
  { src: 'https://tailwindui.com/plus/img/logos/158x48/statamic-logo-gray-900.svg', alt: 'Statamic' },
];

// Duplicate logos for seamless infinite scroll
const scrollingLogos = [...logos, ...logos, ...logos];

const LogoScrollLTR = () => (
  <div className="w-full bg-white  flex flex-col items-center justify-center py-8 mb-24">
    <h2 className="text-2xl md:text-4xl font-bold text-center mb-6 text-gray-900 py-10">
    Our Clients
    </h2>
    <div className="relative w-full max-w-4xl mx-auto overflow-hidden group">
      {/* Gradient fade on edges */}
      <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white to-transparent z-10" />
      {/* Scrolling logos */}
      <div className="flex items-center gap-12 animate-logo-scroll-ltr">
        {scrollingLogos.map((logo, idx) => (
          <img
            key={idx}
            src={logo.src}
            alt={logo.alt}
            className="h-10 w-auto object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
            loading="lazy"
            draggable="false"
          />
        ))}
      </div>
    </div>
    {/* Custom animation */}
    <style>{`
      @keyframes logo-scroll-ltr {
        0% { transform: translateX(0); }
        100% { transform: translateX(-33.333%); }
      }
      .animate-logo-scroll-ltr {
        animation: logo-scroll-ltr 3s linear infinite;
        will-change: transform;
      }
      .group:hover .animate-logo-scroll-ltr {
        animation-play-state: paused;
      }
    `}</style>
  </div>
);

export default LogoScrollLTR;